import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import { p as props, d as defaults } from './componentEl-c8b73b10.js';
import { a as addClassNames, c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { a as addSpacingClasses, v as verticalMarginPropTypes, d as verticalPaddingPropTypes } from './spacing-7e57ffb0.js';

/*
outermost wrapper for page, to limit width of page contents
separate from Grid because we don't always need to limit the width of the grid (e.g. nested grids)
*/
function PageWrapper({
  componentEl: Component,
  className,
  children,
  margin,
  padding,
  ...otherProps
}) {
  let cssClasses = ['st_pagewrapper'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    padding,
    margin,
    cssClasses,
    denylistMargin: ['all', 'horizontal', 'left', 'right'],
    denylistPadding: ['all', 'horizontal', 'left', 'right']
  });
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), children);
}
PageWrapper.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,
  /** any extra CSS classes */
  className: classNamePropTypes,
  /** optional margin, VERTICAL only */
  margin: verticalMarginPropTypes,
  /** optional padding, VERTICAL only */
  padding: verticalPaddingPropTypes
};
PageWrapper.defaultProps = {
  componentEl: defaults,
  className: null,
  margin: null,
  padding: null
};

export { PageWrapper as P };
